// DO NOT EDIT: autogenerated by brokkr
import { CreateIconOptions } from "./types";
export const falO: CreateIconOptions = {
  "displayName": "FALO",
  "viewBox": "0, 0, 448, 512",
  "d": "M224 64a192 192 0 1 0 0 384 192 192 0 1 0 0-384zM448 256A224 224 0 1 1 0 256a224 224 0 1 1 448 0z"
};
